import * as React from "react"
import styled from "styled-components"

const Tags = (props) => {
  return (
    <TagsList>
      {props.list.map((tag, index) => {
          return ( <TagItem key={index}>{tag}</TagItem> )
        })}
    </TagsList>
  )
}

const TagsList = styled.div`
  margin-bottom: 2rem;

  .pp-info & {
    margin-top: .5rem;
  }
`

const TagItem = styled.div`
  display: inline-block;
  margin-right: .7rem;
  margin-bottom: .7rem;
  border-style: solid;
  border-width: 1px;
  padding: .1rem .8rem;
  border-radius: 1.5rem;
`

export default Tags
